import React from "react";
import { Modal, Btn } from "@/components/UI";
import { AlertTriangle } from "lucide-react";
import { fmtQty } from "@/lib/products";

// Bitmiş ürün PO onayı: bağlı malzemeler (stok + açık malzeme siparişi) yetmiyorsa uyarı.
export function MaterialShortageModal({ data, onClose, onForce }) {
  if (!data) return null;
  return (
    <Modal open onClose={onClose} title={`Malzeme Eksikliği — ${data.po_no || "Satın Alma"}`} size="lg">
      <div className="space-y-3" data-testid="material-shortage-modal">
        <div className="flex items-start gap-2 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-3">
          <AlertTriangle size={16} className="mt-0.5 shrink-0" />
          Bu siparişteki ürünler teslim alındığında aşağıdaki ambalaj/malzemeler yetmeyecek (mevcut stok + açık malzeme siparişleri hesaba katıldı).
        </div>
        <table className="w-full text-xs">
          <thead className="bg-slate-50"><tr>{["Ürün", "Malzeme", "Gerekli", "Mevcut", "Açık Sipariş", "Eksik"].map((h) => <th key={h} className="text-left px-2 py-1.5">{h}</th>)}</tr></thead>
          <tbody>
            {data.shortages.map((s) => (
              <tr key={s.material_id} className="border-t border-slate-100" data-testid={`shortage-row-${s.material_id}`}>
                <td className="px-2 py-1.5">{s.product_name}</td>
                <td className="px-2 py-1.5">{s.material_name} <span className="text-slate-400">({s.material_type})</span></td>
                <td className="px-2 py-1.5 font-mono">{fmtQty(s.required)}</td>
                <td className="px-2 py-1.5 font-mono">{fmtQty(s.stock_qty)}</td>
                <td className="px-2 py-1.5 font-mono">{fmtQty(s.open_po_qty)}</td>
                <td className="px-2 py-1.5 font-mono font-bold text-rose-600" data-testid={`shortage-qty-${s.material_id}`}>{fmtQty(s.shortage)} {s.unit}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-end gap-2">
          <Btn variant="secondary" onClick={onClose} data-testid="material-shortage-cancel">Vazgeç</Btn>
          <Btn variant="warn" onClick={onForce} data-testid="material-shortage-force">Yine de Onayla</Btn>
        </div>
      </div>
    </Modal>
  );
}
